const commonDateFormats = {
  dayMonthYearFormat: 'M/DD/YYYY',
  naturalLongDateFormat: 'MMM Do YYYY',
  naturalShortDayMonthYearFormat: 'MMM D YYYY',
  naturalShortDayMonthFormat: 'MMM D'
};

export const SUPPORTED_DATE_FORMATS = [
  { ...commonDateFormats, label: 'M/DD/YYYY', dayMonthYearFormat: 'M/DD/YYYY' },
  { ...commonDateFormats, label: 'DD/MM/YYYY', dayMonthYearFormat: 'DD/MM/YYYY' },
  { ...commonDateFormats, label: 'DD.MM.YYYY', dayMonthYearFormat: 'DD.MM.YYYY' },
  { ...commonDateFormats, label: 'YYYY/MM/DD', dayMonthYearFormat: 'YYYY/MM/DD' },
  { ...commonDateFormats, label: 'YYYY-MM-DD', dayMonthYearFormat: 'YYYY-MM-DD' }
];
